/**
 * Component that creates a wall of KPIWidgets
 * required params:
 *  - data
 */

import React from "react";
/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
import PanelsBoard from "../PanelsBoard";
import PropTypes from "prop-types";
import KPIWidgetPrototype from "./KPIWidgetPrototype";

function KPIBoard({
    width,
    height,
    columns = 3,
    data,
    rows = 2,
    tiles,
    setKPI,
    setSettings,
    inVRMode,
    FrontPanelWidget,
    InfoWidget,
    SettingsWidget,
    aframeClasses,
    ...otherAttributes
}) {
    // fill the layout matrix with KPIWidgets
    const createKPI = () => {
        return Object.keys(data.list).map((elem, i) => {
            return (
                <KPIWidgetPrototype
                    key={i}
                    value={data.list[elem]}
                    label={elem}
                    tile={tiles}
                    settings={data.settings[elem]}
                    currentlyOpened={data.opened}
                    setKPI={setKPI}
                    setSettings={setSettings}
                    inVRMode={inVRMode}
                    FrontPanelWidget={FrontPanelWidget}
                    aframeClasses={aframeClasses}
                    InfoWidget={InfoWidget}
                    SettingsWidget={SettingsWidget}
                />
            );
        });
    };

    return (
        <PanelsBoard
            width={width}
            height={height}
            rows={tiles ? Object.keys(data.list).length : rows}
            columns={columns}
            class="KPIBoard"
            zOffset={false}
            aframeClasses={aframeClasses}
            {...otherAttributes}
        >
            {data.list && createKPI()}
        </PanelsBoard>
    );
}

KPIBoard.propTypes = {
    data: PropTypes.object.isRequired,
    setKPI: PropTypes.func.isRequired,
    setSettings: PropTypes.func.isRequired,
    FrontPanelWidget: PropTypes.func.isRequired,
    InfoWidget: PropTypes.func.isRequired,
    SettingsWidget: PropTypes.func.isRequired
};

export default KPIBoard;
